(() => {
  'use strict';
  const read = (key) => {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; }
  };
  const write = (key, value) => {
    try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };
  const sourceKey = 'ga-selection:';
  const start = () => {
    if (/^\/(collections|search)(\/|$)/.test(location.pathname)) {
      document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href*="/products/"]');
        if (!link) return;
        const product = new URL(link.href, location.href);
        if (product.origin !== location.origin) return;
        write(sourceKey + product.pathname, {
          url: location.pathname + location.search,
          scroll: window.scrollY,
          shown: Number(document.querySelector('.ga-catalog-grid')?.dataset.gaShown) || 24,
          open: !!document.querySelector('.ga-refine details[open]'),
          time: Date.now()
        });
      });
    }
    const back = document.querySelector('.gabriel-product-back__link');
    const source = read(sourceKey + location.pathname);
    if (back && source && Date.now() - source.time < 7200000 && /^\/(collections|search)(\/|\?|$)/.test(source.url)) {
      const target = new URL(source.url, location.origin);
      if (target.origin === location.origin) {
        back.href = target.href;
        if (/^\/search\/?$/.test(target.pathname)) back.textContent = "← " + back.dataset.searchLabel;
        back.addEventListener('click', () => write('ga-selection-restore', source));
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  if (customElements.get('gabriel-mobile-purchase')) return;
  customElements.define('gabriel-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById('MainProduct-' + this.dataset.section);
      this.source = document.getElementById('ProductSubmitButton-' + this.dataset.section);
      this.button = this.querySelector('button');
      this.price = this.querySelector('.ga-mobile-purchase__price');
      this.variant = this.querySelector('.ga-mobile-purchase__variant');
      if (!this.main || !this.source) return;
      this.media = window.matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.onBuy = () => {
        this.update();
        if (!this.button.disabled) this.source.click();
      };
      this.button.addEventListener('click', this.onBuy);
      this.main.addEventListener('change', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.main, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden']});
      this.intersection = new IntersectionObserver(this.schedule, {threshold: [0, 1]});
      this.intersection.observe(this.source);
      const title = this.main.querySelector('.product__title');
      if (title) this.intersection.observe(title);
      this.media.addEventListener('change', this.schedule);
      window.addEventListener('scroll', this.schedule, {passive: true});
      this.update();
    }
    update() {
      const priceRoot = document.getElementById('price-' + this.dataset.section);
      const priceBox = priceRoot?.querySelector('.price');
      const price = priceRoot?.querySelector(priceBox?.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      const picker = this.main.querySelector('variant-selects');
      const selected = picker ? [...picker.querySelectorAll('input:checked,select')].map(input => input.value).filter(Boolean).join(' · ') : '';
      const amount = this.main.querySelector('quantity-input input')?.value || '1';
      const summary = (Number(amount) > 1 ? amount + ' × ' : '') + selected;
      const priceText = priceRoot?.matches('.hidden, .visibility-hidden, [hidden]') ? '' : price?.textContent.trim() || '';
      if (this.price.textContent !== priceText) this.price.textContent = priceText;
      if (this.variant.textContent !== summary) this.variant.textContent = summary;
      const label = this.source.querySelector('span')?.textContent.trim() || this.source.textContent.trim();
      if (label && this.button.textContent !== label) this.button.textContent = label;
      this.button.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true' || this.source.classList.contains('loading');
      const rect = this.source.getBoundingClientRect();
      const title = this.main.querySelector('.product__title')?.getBoundingClientRect();
      const visible = rect.bottom > 0 && rect.top < window.innerHeight;
      this.hidden = !this.media.matches || visible || !title || title.top > window.innerHeight || !priceText;
      document.body.classList.toggle('ga-has-purchase-bar', !this.hidden);
      if (!this.hidden) document.body.style.setProperty('--ga-purchase-height', this.offsetHeight + 'px');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.media?.removeEventListener('change', this.schedule);
      this.main?.removeEventListener('change', this.schedule);
      window.removeEventListener('scroll', this.schedule);
      cancelAnimationFrame(this.frame);
      document.body.classList.remove('ga-has-purchase-bar');
    }
  });
})();

